import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Button,
    Header,
    Textarea,
    Container,
    SpaceBetween,
    Box,
    Grid,
    Link,
    ExpandableSection,
    FileUpload,
    Modal,
    Spinner,
    Checkbox,
    ColumnLayout,
    Select,
    ButtonDropdown,
    StatusIndicator,
    Popover,
    Table,
    Alert,
    Flashbar,
    Input,
    FormField
} from "@amzn/awsui-components-react";
import { AgGridReact } from 'ag-grid-react';

import './styles.scss'
import { configureFlexicoS3, configureFriscoS3, configureTANCS3 } from 'src/context/AuthContextUtility';
import { Storage } from 'aws-amplify';
import * as d3 from "d3";
import { CellDataType } from 'src/utilities/ag-grid-utils';
import { createPreferenceWithExtras, deletePreference, getBrassAllLDAPS, getPresignedUrlForVersionFile, getTANCSession, listPreference, listTANCVersions, onNotifyUpdate, tancSave, tancSync, tancUpdateSubscribers, updateTANCLock, updatePreferenceWithExtras } from 'src/utilities/AppSyncPlusAPIs';
import { useSelector } from 'react-redux';
import { createAuditLog } from '../Templates/Utils/AppActivityUtils';
import { v4 as uuidv4 } from 'uuid';
import { CUSTOM_TAG, PERSONAL_TAG } from './constants';
import { deepEqual, filterNullsInObjectArrays } from '../utils/generalUtils';
import { getDocumentFromVault, uploadDocumentToVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from "src/Ateam-BI/Vault/constants";
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';


const TANCSession = (props) => {
    const gridRef = useRef();
    const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
    const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const userId = useSelector((globalState) => globalState.auth.userId)
    const [dsInfo, setDsInfo] = useState([])
    const [columnsList, setColumnsList] = useState([])
    const [gridInfo, setGridInfo] = useState({ rowCount: 0, totalRows: 0 });
    const [aggregationValues, setAggregationValues] = useState(null)
    const [sessionDetails, setSessionDetails] = useState(null)
    const [annotationLoader, setAnnotationLoader] = useState(null)
    const [annotationError, setAnnotationError] = useState("error..")
    const [undoEditCount, setUndoEditCount] = useState(0)
    const [selectedRowIndex, setSelectedRowIndex] = useState(0)
    const [multiSelectedRow, setMultiSelectedRow] = useState([])
    const [rowGroupColumns, setRowGroupColumns] = useState([])
    const [showAnnotationImportModal, setShowAnnotationImportModal] = useState(false)
    const [showAnnotationImportAppendModal, setShowAnnotationImportAppendModal] = useState(false)
    const [annotationSaveSuccessMessage, setAnnotationSaveSuccessMessage] = useState(null)
    const [showSyncRequestCommentModal, setShowSyncRequestCommentModal] = useState(false)
    const [showHistoryModal, setShowHistoryModal] = useState(false)
    const [syncRequestComment, setSyncRequestComment] = useState(null)
    const [requestSyncCommentErrorMessage, setRequestSyncCommentErrorMessage] = useState(null)
    const [syncLoaderMessage, setSyncLoaderMessage] = useState(null)
    const [historyLoaderMessage, setHistoryLoaderMessage] = useState(null)
    const [historyErrorMessage, setHistoryErrorMessage] = useState(null)
    const [permissions, setPermissions] = useState([])
    const [filters, setFilters] = useState([])
    const [customFilters, setCustomFilters] = useState({})
    const [configurationMap, setConfigurationMap] = useState({});
    const [filterThatApplyToAlias, setFilterThatApplyToAlias] = useState([]);
    const [selectedFilterOption, setSelectedFilterOption] = useState(null);
    const [tancFilterModel, setTANCFilterModel] = useState(null);
    const [viewers, setViewers] = useState({});
    const [historyData, setHistoryData] = useState([])
    const [resubmitTimestamp, setResubmitTimestamp] = useState(null)
    const [resubmitVersionData, setResubmitVersionData] = useState(null)
    const [flashMessages, setFlashMessages] = useState([])
    const [showSaveModal, setShowSaveModal] = useState(false)
    const [showSaveCurrentFiltersModal, setShowSaveCurrentFiltersModal] = useState(false)
    const [currentFilterName, setCurrentFilterName] = useState("")
    const [hasFilterDiff, setHasFilterDiff] = useState(false)
    const [saveRequestComment, setSaveRequestComment] = useState(null) 
    const [requestSaveCommentErrorMessage, setRequestSaveCommentErrorMessage] = useState(null)
    const [tancUserRoleMap, setTancUserRoleMap] = useState({})
    const [savedFormulas, setSavedFormulas] = useState(null)
    const [savedColumnFormulas, setSavedColumnFormulas] = useState(null)
    const [formulaPreferenceId, setFormulaPreferenceId] = useState(null)
    const [hasUnsavedFormula, setHasUnsavedFormula] = useState(false)
    const [pendingFormula, setPendingFormula] = useState(null)
    const [pendingFormulaRemoval, setPendingFormulaRemoval] = useState(null)
    const [showColumnFormulaOverrideWarning, setShowColumnFormulaOverrideWarning] = useState(null)
    const annotationLevel = "public"

    useEffect(() => {
        const interval = setInterval(() => {
            notifyViewing()
            cleanUpViewers()
        }, 30000);
        notifyViewing()

        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (sessionDetails?.s3Uri) {
            getAnnotationInput()
            notificationUpdates()
        }
        return () => {
        };
    }, [sessionDetails?.s3Uri]);

    useEffect(() => {
        return () => {
            tancUpdateSubscribers(sessionDetails?.sessionId, { "type": "VIEWER", "alias": userId, "action": "DEREGISTER" } || {}, function onSuccess(result) {
            }, function onFailure(result) {
            })
        };
    }, [sessionDetails?.sessionId]);

    useEffect(() => {
        if (props?.sessionDetails) {
            setSessionDetails(props.sessionDetails)
        }
        if (props?.tancDetails) {
            loadAllPreferences()
        }
        return () => {
        };
    }, [props]);

    useEffect(() => {
        if (configurationMap && dsInfo) {
            cleanData()
            setColumnDefinition()
        }
        return () => {
        };
    }, [configurationMap]);

    useEffect(() => {
        if (selectedFilterOption) {
            setColumnDefinition()
        }
        return () => {
        };
    }, [selectedFilterOption]);

    useEffect(() => {
        setColumnDefinition()
        return () => {
        };
    }, [sessionDetails?.isLocked]);

    useEffect(() => {
        if (tancFilterModel && gridRef?.current?.api) {
            gridRef?.current?.api?.setFilterModel(tancFilterModel);
            gridRef?.current?.api.onFilterChanged();
        }
        return () => {
        };
    }, [tancFilterModel]);

    const defaultProjectColDef = {
        resizable: true,
        sortable: true,
        autoHeaderHeight: true,
        floatingFilter: true,
        headerClass: 'header-center',
        editable: false,
        // singleClickEdit: true,
        enableCellChangeFlash: true,
        enableRowGroup: false,
        enableCellChangeFlash: true,
        suppressHeaderMenuButton: false,
        enableHeaderHighlight: true,
        suppressMovable: true,
        cellClassRules: {
            'edited-row': (params) => { return params?.data?.isEdited || params?.data?.isNew },
            'new-row': (params) => { return params?.data?.isNew },
        },
        minWidth: 150,
    };

    const sideBar = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
            },
            {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
            }
        ],
        // Hide sidebar by default
        defaultToolPanel: '', // empty string means closed
        // or use 'false' to hide completely
        // defaultToolPanel: false,
    };


    function notificationUpdates() {
        onNotifyUpdate(sessionDetails?.sessionId, function onResult(result) {
            let validationResponse = JSON.parse(result.value.data.onNotifyUpdate.payload)
            if (validationResponse?.type == 'SYNC_STATUS'
                && validationResponse?.message
                && validationResponse?.message == 'success') {
                unlockSession()
            }

            if (validationResponse?.action == 'RELOAD') {
                setResubmitTimestamp(null);
                getAnnotationInput(true)
            }

            if (validationResponse?.type == 'LOCK_STATUS') {
                getTANCSession(sessionDetails?.sessionId, function onSuccess(result){
                    setSessionDetails(result?.data?.getTANCSession)
                }, function onFailure(result){
                    
                })
            }

            if (validationResponse?.type == 'VIEWER'
                && validationResponse?.alias && validationResponse?.action
            ) {
                if (validationResponse?.action == 'REGISTER' && validationResponse?.alias != userId) {
                    // add to set
                    viewers[validationResponse.alias] = Date.now()
                    setViewers({ ...viewers })
                } else if (validationResponse?.action == 'DEREGISTER') {
                    // remove from set
                    setViewers(prevData => {
                        const newData = { ...prevData };
                        delete newData[validationResponse.alias];
                        return newData;
                    });
                }
            }
        }, function onFailure(error) {
            // console.log(error)
        })
    }
    function notifyViewing() {
        if (props?.sessionDetails?.sessionId) {
            tancUpdateSubscribers(props?.sessionDetails.sessionId, { "type": "VIEWER", "alias": userId, "action": "REGISTER" } || {}, function onSuccess(result) {
            }, function onFailure(result) {
            })
        }
    }
    function cleanUpViewers() {
        const fiveMinutesAgo = Date.now() - (1 * 60 * 1000);

        setViewers(prevData => {
            const newData = { ...prevData };
            Object.keys(newData).forEach(key => {
                if (newData[key] < fiveMinutesAgo) {
                    delete newData[key];
                }
            });
            return newData;
        });
    }

    const resetGridView = () => {
        if (gridRef.current) {
            const gridApi = gridRef.current.api;
            const columnApi = gridRef.current.columnApi;

            // Clear Filters
            gridApi?.setFilterModel(null);

            // Clear Sorting
            columnApi?.applyColumnState({
                defaultState: { sort: null },
            });

            // Reset Columns
            columnApi?.resetColumnState();

            // Reset Pinned Columns
            columnApi?.setPivotMode(false);

            // // Resize to fit
            // gridApi?.sizeColumnsToFit();

            // Redraw the grid
            gridApi?.redrawRows();
        }
    };

    function getS3PathAndFileName(s3Uri) {
        // Remove 's3://' and split by '/'
        const parts = s3Uri?.replace('s3://', '').split('/');

        // Remove bucket (first element) and filename (last element)
        parts.shift(); // Remove bucket
        const fileName = parts.pop();   // Remove filename
        let path = parts.join('/');
        path = `${path}/`
        return {
            path,
            fileName
        }
    }

    function cleanViewBeforeLoad(resetView = false) {
        setAnnotationLoader('Loading..')
        setAnnotationError(null)
        setDsInfo(null)
        setColumnsList(null)
        setSelectedRowIndex(null)
        setUndoEditCount(0)
        setMultiSelectedRow([])
        setAggregationValues(null)
        if (!resetView) {
            resetGridView()
        }
    }

    function setViewOnTheGrid(result) {
        // assign unique rowIds for AG Grid formulas to find rows/save formulas
        result.forEach((row, index) => {
            row._tancRowId = String(index);
        });
        totalRowsRef.current = result.length;
        nextRowIdRef.current = result.length;
        setDsInfo(result)
        cleanData()
        setColumnDefinition(result)
        setAnnotationLoader(null)
        setAnnotationError(null)
    }

    const getAnnotationInput = async (resetView = false) => {
        cleanViewBeforeLoad(resetView)
        const sessionFileDetails = getS3PathAndFileName(sessionDetails?.s3Uri)
        let level = annotationLevel
        let prefix = sessionFileDetails['path']
        configureTANCS3()
        let arr = sessionFileDetails['fileName'].split('.')
        let contentType = arr[arr.length - 1]
        // let fileURL = await Storage.get(sessionFileDetails['fileName'], { level: level, customPrefix: { public: prefix }, expires: 60 });
        let document = await getDocumentFromVault(contentType, VAULT_SERVICES.TANC, {"file_path": `${prefix}${sessionFileDetails['fileName']}`, "service_id":`${sessionDetails.tancId}`, "app_id":`${sessionDetails.sessionId}`})                
        let fileURL = document?.fileUrl
        await d3.csv(fileURL).then((result) => {
            setViewOnTheGrid(result)
        }).catch((response) => {
            setAnnotationLoader(null)
            setAnnotationError('Loading failed')
        });
    }


    function cleanData() {
        if (dsInfo == null || configurationMap == null) {
            return
        }
        dsInfo.forEach(row => {
            Object.keys(configurationMap).forEach(colName => {
                if ((configurationMap[colName]?.data_type === 'INTEGER' || configurationMap[colName]?.data_type === 'DECIMAL') && row[colName]) {
                    row[colName] = Number(row[colName]) || 0;
                }
            });
        });
    }

    function isEditorRole() {
        return selectedFilterOption?.extra?.role == 'EDITOR' || selectedFilterOption?.extra?.role == 'ADMIN' || selectedFilterOption?.extra?.role == 'REVIEWER'
    }
    function isEditable(colName) {
        if (!isEditorRole()) {
            return false
        }
        if (selectedFilterOption && selectedFilterOption?.value == 'All') {
            return true
        }
        try {
            let extras = JSON.parse(filters[selectedFilterOption?.value]?.extras)
            if (extras?.allEdit) {
                return true
            } else {
                let filter = JSON.parse(filters[selectedFilterOption?.value]?.information)
                for (const i in filter) {
                    if (filter[i].column_name == colName) {
                        return filter[i].can_edit
                    }
                }
                return false
            }
        } catch (e) {
            // console.log(e)
            return false
        }
    }

    const getMaxLengthForCellField = (tableDefinition, configurationMap) => {
        let length = 2000
        try {
            if (tableDefinition?.cellDataType == CellDataType.TEXT && (configurationMap[tableDefinition.field] || null)?.length) {
                length = configurationMap[tableDefinition.field].length
            }
        } catch (e) {

        }
        return length
    }

    const getDateString = (date) => {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            return null;
        }
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${date.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
    }

    const setColumnDefinition = (input) => {
        let data = dsInfo
        if (input) {
            data = input
        }
        let filterModel = {}
        if (data?.columns) {
            const definitions = []
            for (let i = 0; i < data?.columns?.length; i++) {
                let colName = data?.columns[i]
                let def = {
                    field: colName, headerName: colName, resizable: true, sortable: true, enableRowGroup: !(sessionDetails?.isLocked && sessionDetails?.lockedBy == userId) && formulaStoreRef.current.size === 0 && columnFormulaStoreRef.current.size === 0, editable: false,
                    filter: 'agMultiColumnFilter',
                    filterParams: {
                        closeOnApply: false,
                        defaultOption: 'contains',
                        trimInput: true,
                        caseSensitive: false,
                        suppressAndOrCondition: true,
                        filters: [
                            {
                                filter: 'agSetColumnFilter',
                                filterParams: {
                                    buttons: ['apply', 'clear'],
                                    suppressSelectAll: false,
                                    excelMode: 'windows',
                                    valueFormatter: (params) => {
                                        return params.value != null ? params.value?.toString() : '(Blank)';
                                    },
                                    applyValueImmediately: false
                                }
                            },
                        ]
                    },

                    cellClass: (params) => {
                        const colId = params?.column?.getColId();
                        const nodeId = params?.node?.id;
                        const key = nodeId && colId ? `${nodeId}-${colId}` : null;
                        const isTemporaryEdit = key ? temporaryEditFormulaCellsRef.current.has(key) : false;
                        const hasColumnFormula = colId && !isTemporaryEdit ? columnFormulaStoreRef.current.has(colId) : false;
                        const hasCellFormula = key ? formulaStoreRef.current.has(key) : false;
                        return [
                            params?.column?.colDef?.editable ? 'editable-cell' : '',
                            params?.data?.isEdited?.hasOwnProperty(colName) ? 'edited-cell' : '',
                            (hasColumnFormula || hasCellFormula) ? 'formula-cell' : '',
                        ].filter(Boolean);
                    }
                }
                if (i == 0) {
                    def['checkboxSelection'] = true
                    def['headerCheckboxSelection'] = true
                }

                if (isEditable(colName) && sessionDetails?.isLocked && sessionDetails?.lockedBy == userId) {
                        def['editable'] = true
                    } else {
                        def['editable'] = false
                    }
                if (configurationMap.hasOwnProperty(colName)) {
                    // check edit types
                    if (configurationMap[colName]?.edit_type == 'SELECT') {
                        def['cellEditor'] = 'agRichSelectCellEditor'
                        def['cellEditorParams'] = {
                            values: configurationMap[colName]?.field_tokens?.map(token => token.label) || [],
                        }
                    } else if (configurationMap[colName]?.edit_type == 'MULTI_SELECT') {
                        def['cellEditor'] = 'agRichSelectCellEditor'
                        def['cellEditorParams'] = {
                            values: configurationMap[colName]?.field_tokens?.map(token => token.label) || [],
                            multiSelect: true
                        }
                        def['valueFormatter'] = (params) => {
                            return Array.isArray(params.value) ? params.value.join(', ') : params.value;
                        };
                        def['valueParser'] = (params) => {
                            if (typeof params.newValue === 'string') {
                                return params.newValue.split(',').map(item => item.trim());
                            }
                            return params.newValue || [];
                        };
                        def['valueGetter'] = (params) => {
                            if (!params.data[colName]) return [];

                            // If it's already an array, return it
                            if (Array.isArray(params.data[colName])) {
                                return params.data[colName];
                            }

                            // If it's a string, convert to array
                            if (typeof params.data[colName] === 'string') {
                                return params.data[colName].split(',').map(item => item.trim());
                            }

                            return [];
                        };
                    } else {
                        def['cellEditor'] = 'agTextCellEditor'
                        def['cellDataType'] = CellDataType.TEXT
                        def['valueParser'] = (params) => {
                            return params.newValue || ''; // Ensure non-null value
                        };
                        def['valueFormatter'] = (params) => {
                            return params.value || '';
                        };


                        // check data types
                        if (configurationMap[colName]?.data_type == 'BOOLEAN') {
                            def['cellDataType'] = CellDataType.BOOLEAN
                        } else if (configurationMap[colName]?.data_type == 'DATE') {
                            def['cellDataType'] = CellDataType.DATE
                            def['valueFormatter'] = (params) => {
                                if(params.value instanceof Date){
                                    return getDateString(params.value)
                                }
                                return params.value
                            };
                            def['valueGetter'] = (params) => {
                                if(params.data?.[colName] instanceof Date){
                                    return getDateString(params.data?.[colName])
                                }
                                return params.data?.[colName]
                            };
                            def['valueParser'] = (params) => {
                                const parsedDate = new Date(params.newValue+ "T00:00:00");
                                if (parsedDate instanceof Date && !isNaN(parsedDate)) {
                                    return parsedDate
                                }
                                // Return previous value if invalid
                                return params.oldValue;
                            };

                        } else if (configurationMap[colName]?.data_type == 'INTEGER') {
                            delete def['cellEditor']
                            def['cellDataType'] = CellDataType.NUMBER
                            def['allowFormula'] = true
                            def['valueFormatter'] = (params) => {
                                if (typeof params.value === 'string' && params.value.startsWith('=')) return 0;
                                const value = Number(params.value);
                                if (isNaN(value)) return params.value;
                                return value.toFixed(0);
                            };
                            def['valueParser'] = (params) => {
                                if (typeof params.newValue === 'string' && params.newValue.startsWith('=')) return params.newValue;
                                const value = Number(params.newValue);
                                return isNaN(value) ? 0 : parseInt(value);
                            };
                        }else if (configurationMap[colName]?.data_type == 'DECIMAL') {
                            delete def['cellEditor']
                            def['cellDataType'] = CellDataType.NUMBER
                            def['allowFormula'] = true
                            def['valueFormatter'] = (params) => {
                                if (typeof params.value === 'string' && params.value.startsWith('=')) return 0;
                                const value = Number(params.value);
                                if (isNaN(value)) return params.value;
                                return value;
                            };
                            def['valueParser'] = (params) => {
                                if (typeof params.newValue === 'string' && params.newValue.startsWith('=')) return params.newValue;
                                const value = Number(params.newValue);
                                return isNaN(value) ? 0 : value;
                            };
                        }else if (configurationMap[colName]?.data_type == 'CURRENCY') {
                            delete def['cellEditor']
                            def['valueFormatter'] = (params) => {
                                if (typeof params.value === 'string' && params.value.startsWith('=')) return 0;
                                return currencyFormatter(params);
                            }
                            def['valueGetter'] = (params) => {
                                const val = params.data?.[colName];
                                if (typeof val === 'string' && val.startsWith('=')) return 0;
                                return Number(val) || 0;
                            }
                            def['valueParser'] = (params) => {
                                if (typeof params.newValue === 'string' && params.newValue.startsWith('=')) return params.newValue;
                                const cleanValue = params.newValue.toString().replace(/[^0-9.]/g, '');
                                const parsedValue = Number(cleanValue);
                                return isNaN(parsedValue) ? (params.oldValue || 0) : parsedValue;
                            }
                            def['cellDataType'] = CellDataType.NUMBER
                            def['allowFormula'] = true
                        }else if (configurationMap[colName]?.data_type == 'VARCHAR') {
                            def['cellDataType'] = CellDataType.TEXT
                            def['cellEditor'] = 'agLargeTextCellEditor'
                            def['cellEditorPopup'] = true
                            def['cellEditorParams'] = {
                                maxLength: getMaxLengthForCellField(def, configurationMap),
                                rows: 5,
                                cols: 50
                            }
                        } else {
                            def['cellEditorParams'] = {
                                maxLength: getMaxLengthForCellField(def, configurationMap),
                                onKeyDown: (event) => {
                                    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                    if (!allowedKeys.includes(event.key) &&
                                        !/^[0-9.]$/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }
                            }
                        }
                    }

                    if (configurationMap[colName]?.data_type == 'DECIMAL'
                        || configurationMap[colName]?.data_type == 'INTEGER'
                        || configurationMap[colName]?.data_type == 'CURRENCY') {
                        def['filterParams']['filters'].push({
                            filter: 'agNumberColumnFilter',
                            filterParams: {
                                buttons: ['apply', 'clear'],
                            }
                        })
                    } else if (configurationMap[colName]?.data_type == 'DATE') {
                        def['filterParams']['filters'].push({
                            filter: 'agDateColumnFilter',
                            filterParams: {
                                buttons: ['apply', 'clear'],
                            }
                        })
                    } else {
                        def['filterParams']['filters'].push({
                            filter: 'agTextColumnFilter',
                            filterParams: {
                                closeOnApply: false,
                                buttons: ['apply', 'clear'],
                                filterOptions: [
                                    'equals',
                                    'notEqual',
                                    'contains',
                                    'notContains',
                                    'startsWith',
                                    'endsWith'
                                ]
                            }
                        })
                    }

                    // apply filters
                    if (selectedFilterOption
                        && selectedFilterOption.value
                        && filters.hasOwnProperty(selectedFilterOption.value)
                        && filters[selectedFilterOption.value]?.information) {
                        let filterConfig = JSON.parse(filters[selectedFilterOption.value]?.information)
                        for (const i in filterConfig) {
                            if (filterConfig[i].column_name == colName && filterConfig[i].field_tokens?.length > 0) {
                                const values = filterConfig[i].field_tokens?.map(item => item.label);
                                filterModel[colName] = {
                                    filterType: 'multi',
                                    // first element should always be a 'set' that is default applied filter. CANNOT BE NULL since this is referenced in the onFilterChanged to reset the filter if default is changed
                                    filterModels: [
                                        {
                                            filterType: 'set',
                                            values: values
                                        }
                                        // null is required. DONOT REMOVE. If filters are auto applied and for complex filter involving set and other filter types, auto apply fails. Even aggrid adds null for default behaviours. 
                                    ]
                                }
                            }
                        }
                    }

                    if (selectedFilterOption
                        && selectedFilterOption.value
                        && customFilters.hasOwnProperty(selectedFilterOption.value)
                        && customFilters[selectedFilterOption.value]?.information) {

                        const customFilterConfig = JSON.parse(customFilters[selectedFilterOption?.value]?.information)
                        let originalFilterId = JSON.parse(customFilters[selectedFilterOption?.value]?.extras).originalFilterId;
                        let originalFilter = filters[originalFilterId];
                        let originalFilterConfig, applicableOriginalFilter;
                        
                        if (originalFilter) {
                            originalFilterConfig = JSON.parse(filters[originalFilterId]?.information)
                            applicableOriginalFilter = originalFilterConfig.find(originalFilter => originalFilter.column_name == colName);
                        } 

                        if (customFilterConfig[colName] || applicableOriginalFilter) {
                            let filterModels = []

                            const values = applicableOriginalFilter?.field_tokens ? applicableOriginalFilter.field_tokens?.map(item => item.label) : [];
                            filterModels.push({
                                filterType: 'set',
                                values: values.length > 0 ? values : null,
                            })

                            if (customFilterConfig[colName]) {
                                const filters = customFilterConfig[colName].filterModels;
                                const setFilter = filters.find(filter => filter.filterType === 'set');
                                if (setFilter) {
                                    filterModels[0].values = setFilter.values;
                                }
                                const nonSetFilters = filters.filter(filter => filter.filterType != 'set')
                                filterModels = filterModels.concat(nonSetFilters);
                            }

                            filterModel[colName] = {
                                filterType: 'multi',
                                filterModels
                            }
                        }
                    }

                }
                definitions.push(def)
            }
            setTANCFilterModel(filterModel)
            setColumnsList(definitions)
        }
    }
    const onRegister = (rippleId) => {

    }

    const onDeRegister = (rippleId) => {

    }
    const saveAnnotated = async() => {
        resetSaveRequestModal()
        setAnnotationLoader("Saving the data..")
        if (hasUnsavedFormula) {
            saveFormulas();
        }
        // Force refresh to ensure formula cells have latest computed values before export
        if (gridRef.current?.api) {
            gridRef.current.api.refreshCells({ force: true });
        }
        const sessionFileDetails = getS3PathAndFileName(sessionDetails?.s3Uri)
        let prefix = sessionFileDetails['path']
        prefix = `tmp/${prefix}`
        const [name, ext] = sessionFileDetails['fileName'].split('.');
        const new_filename = `${name}_${Math.floor(Date.now()/1000)}.${ext}`;

        let delta_filename = `delta_${new_filename}`
        if (resubmitTimestamp?.['versionData']?.version) {
            delta_filename = `resubmitted_${resubmitTimestamp?.['versionData']?.lastUpdatedTimestamp}_${resubmitTimestamp?.['versionData']?.version}.csv`
        }
        setResubmitTimestamp(null);
        let dataAltered = gridRef.current?.api.getDataAsCsv({
            'exportedRows': 'all',
            shouldRowBeSkipped: (params) => !params.node.data.isEdited,
            processCellCallback: (params) => {
                return parseExportValue(params);
            },
        })
        configureTANCS3()
        // let putResp = await Storage.vault.put(delta_filename, dataAltered, {
        //                 tagging: `userId=${userId}&tanc_id:${sessionDetails.tancId}&session_id:${sessionDetails.sessionId}`,
        //                 level: annotationLevel,
        //                 customPrefix: { public: prefix },
        //                 acl: 'bucket-owner-full-control'
        //             })
        
        let putResp = await uploadDocumentToVault(ext, VAULT_SERVICES.TANC, {"file_path": `${prefix}/${delta_filename}`, "tagging": `userId=${userId}&tanc_id:${sessionDetails.tancId}&session_id:${sessionDetails.sessionId}`, "service_id":`${sessionDetails.tancId}`, "app_id":`${sessionDetails.sessionId}`}, dataAltered)
        
        let data = gridRef.current?.api.getDataAsCsv({
            'exportedRows': 'all', processCellCallback: (params) => {
                // Access raw data directly from node.data
                return parseExportValue(params);
            },
        })
        configureTANCS3()
        uploadDocumentToVault(ext, VAULT_SERVICES.TANC, {"file_path": `${prefix}${new_filename}`, "service_id":`${sessionDetails.tancId}`, "app_id":`${sessionDetails.sessionId}`}, data)
        // Storage.put(new_filename, data, {
        //     level: annotationLevel,
        //     customPrefix: { public: prefix },
        // })
            .then((result) => {
                setTimeout(() => {
                    setAnnotationSaveSuccessMessage(null)
                }, 1000);
                // Make API call to sync
                tancSave(sessionDetails.sessionId, saveRequestComment, `${result.objectKey}`, 'UPDATE', 'ABC', `${putResp.objectKey}`, function onSuccess(result){

                })
            })
            .catch(err => setAnnotationError("Saving failed"));
    }

    const parseExportValue = (params) => {
        const rawValue = params.node.data[params.column.colDef.field];
        const colId = params.column.colDef.field;
        // If the cell has a column formula or cell-level formula, export the displayed value
        if (columnFormulaStoreRef.current.has(colId) || formulaStoreRef.current.has(`${params.node.id}-${colId}`) || (typeof rawValue === 'string' && rawValue.startsWith('='))) {
            return params.value != null ? params.value : 0;
        }
        if (rawValue instanceof Date) {
            return getDateString(rawValue)
        }
        return rawValue;
    }
    const submitAnnotated = () => {
        if (hasUnsavedFormula) {
            saveFormulas();
        }
        // Force refresh to ensure formula cells have latest computed values before export
        if (gridRef.current?.api) {
            gridRef.current.api.refreshCells({ force: true });
        }
        let dataAltered = gridRef.current?.api.getDataAsCsv({
            'exportedRows': 'all',
            shouldRowBeSkipped: (params) => !params.node.data.isEdited,
            processCellCallback: (params) => {
                return parseExportValue(params);
            },
        })
        let fileName = 'updated'
        if (resubmitTimestamp?.['versionData']?.version) {
            fileName = `resubmitted_${resubmitTimestamp?.['versionData']?.lastUpdatedTimestamp}_${resubmitTimestamp?.['versionData']?.version}`
        }
        setResubmitTimestamp(null);
        if (props?.onSubmit) {
            let data = gridRef.current?.api.getDataAsCsv({
                'exportedRows': 'all', processCellCallback: (params) => {
                    return parseExportValue(params);
                },
            })
            props?.onSubmit(data, dataAltered, fileName)
        }

        if (props?.onSubmitAltered) {
            props?.onSubmitAltered(dataAltered, fileName)
        }
    }

    const nextRowIdRef = useRef(0);

    const addRowToAnnotation = (data = {}) => {
        let copy = Object.assign({}, data)
        copy['isNew'] = true
        const newId = nextRowIdRef.current;
        nextRowIdRef.current = nextRowIdRef.current + 1;
        copy['_tancRowId'] = String(newId);
        const newData = [copy, ...dsInfo];
        totalRowsRef.current = newData.length;
        setDsInfo(newData)
        setUndoEditCount(undoEditCount + 1)
    }

    const delRowToAnnotation = () => {
        const rowIdsToDelete = new Set(
            multiSelectedRow.map(row => row.data._tancRowId)
        );
        const updatedData = dsInfo.filter(row => !rowIdsToDelete.has(row._tancRowId));
        totalRowsRef.current = updatedData.length;
        setDsInfo(updatedData)
        setUndoEditCount(undoEditCount + 1)
    }

    const exportAnnotated = (args = {}) => {
        const sessionFileDetails = getS3PathAndFileName(sessionDetails?.s3Uri)
        let csv = gridRef.current?.api.exportDataAsCsv({
            'fileName': sessionFileDetails['fileName'],
            'exportedRows': args.filtered ? 'filteredAndSorted' : 'all',
            'onlySelected': args.selectedOnly,
            columnKeys: columnsList?.filter(c => c.field !== '_tancRowId').map(c => c.field),
            processCellCallback: (params) => {
                // Access raw data directly from node.data
                if (params.node.group) {
                    // Access grouped value
                    return params.value;
                } else {
                    return parseExportValue(params);
                }

            }
        });
        // gridRef.current?.api.exportDataAsExcel()
    }

    function currencyFormatter(params) {
        if (isNumberAfterParsed(params.value)) {
            return "$" + formatFloatNumber(params.value);
        } else {
            return '-'
        }

    }
    function formatNumber(number) {
        return Math.floor(number).toLocaleString();
    }

    function formatFloatNumber(number) {
        return number.toLocaleString();
    }

    const onCellValueChanged = useCallback((params) => {
        const undoSize = params.api.getCurrentUndoSize();
        setUndoEditCount(undoSize)

        if (params.oldValue !== params.newValue) {
            let editedCols = params.data.isEdited || {}
            if (editedCols.hasOwnProperty(params.column.colId)) {
                // store original old value
                editedCols[params.column.colId] = { oldValue: editedCols[params.column.colId]?.oldValue, newValue: params.newValue }
            } else {
                // new entry
                editedCols[params.column.colId] = { oldValue: params.oldValue, newValue: params.newValue }
            }
            params.data.isEdited = editedCols;
        }
        params.api.refreshCells();
    }, []);

    const onCellFocused = useCallback((params) => {
        setSelectedRowIndex(params.rowIndex)
    }, []);

    const onSelectionChanged = (param) => {
        const selectedNodes = gridRef.current.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => ({
            rowIndex: node.rowIndex,
            data: node.data
        }));
        setMultiSelectedRow(selectedData.sort((a, b) => b.rowIndex - a.rowIndex))
    };

    const onGridReady = useCallback((params) => {
        // gridRef?.current?.api.sizeColumnsToFit();
        const allColumnIds = [];
        gridRef?.current?.api?.getColumns()?.forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridRef?.current?.api?.autoSizeColumns(allColumnIds);
        updateGridInfo()

    }, []);

    const onRowDataUpdated = useCallback(() => {
        if (gridRef?.current?.api && (formulaStoreRef.current.size > 0 || columnFormulaStoreRef.current.size > 0)) {
            gridRef.current.api.refreshCells({ force: true });
        }
    }, []);

    const isNumber = (value) => {
        try {
            if (typeof value === 'number' && !isNaN(value)) {
                return true;
            }
            // if (typeof value === 'string' && !isNaN(Number(value))) {
            //   return true;
            // }
            return false;
        } catch (e) {
            return false
        }
    };

    const isNumberAfterParsed = (value) => {
        try {
            if (typeof value === 'number' && !isNaN(value)) {
                return true;
            }
            if (typeof value === 'string' && !isNaN(Number(value))) {
                return true;
            }
            return false;
        } catch (e) {
            return false
        }
    };

    const getContextMenuItems = (params) => {
        let menuItems = [
            'copy',
            'copyWithHeaders',
            // 'paste',
            'separator',
            'export'
        ]
        if (props.canEdit) {
            menuItems.push('separator')
            menuItems.push({
                name: 'Clone',
                action: () => {
                    addRowToAnnotation(params.node.data)
                }
            })
        }
        return menuItems;
    }

    function notifyFlashMessages(notification) {
        if (notification) {
            let flashMessages = []
            for (const i in notification.messages) {
                flashMessages.push({
                    header: notification.header,
                    type: notification.type,
                    dismissible: true,
                    dismissLabel: "Dismiss message",
                    onDismiss: () => setFlashMessages([]),
                    content: (
                        <>
                            {notification.messages[i]}
                        </>
                    ),
                    id: `message_${i}`
                })
            }
            setFlashMessages(flashMessages)
        }
    }
    function applyFilterModel(model) {
        gridRef.current.api?.setFilterModel(JSON.parse(JSON.stringify(model)));
        gridRef.current.api?.onFilterChanged();
    }

    const getFilterDiff = () => {
        let diff = {};

        if (!gridRef?.current?.api || !tancFilterModel) {
            return diff;
        }
        
        const tancFilters = tancFilterModel || {};
        const currentFilterModel = gridRef.current.api.getFilterModel();
        const currentFilters = filterNullsInObjectArrays(currentFilterModel);

        for (const filterName in currentFilters) {
            const originalFilter = tancFilters[filterName];
            const currentFilter = currentFilters[filterName];

            if (originalFilter) {
                const filteredFilters = currentFilter.filterModels.filter((currentFilterModel) => {
                    return !originalFilter.filterModels.find((originalFilterModel) => deepEqual(originalFilterModel, currentFilterModel))
                })
                filteredFilters.length > 0 && (diff[filterName] = filteredFilters);
            } else {
                diff[filterName] = currentFilter;
            }
        }
        return diff;
    };

    const saveCurrentFilters = async (filterName) => {
        const filterDiff = getFilterDiff();
        const newPreferenceId = uuidv4();
        const createFilter = new Promise((resolve, reject) => {
            createPreferenceWithExtras(
                newPreferenceId,
                `CUSTOM_FILTER#${userId}`,
                filterName,
                props.tancDetails.tanc_id, 
                'TANC',
                userId,
                filterDiff,
                {originalFilterId: selectedFilterOption.value},
                null, // ttl
                () => {
                    setShowSaveCurrentFiltersModal(false);

                    const filter = {
                        label: filterName,
                        value: newPreferenceId,
                        extra: {originalFilterId: selectedFilterOption.value},
                        tags: [PERSONAL_TAG, CUSTOM_TAG]
                    }

                    const localCustomFilters = structuredClone(customFilters);
                    localCustomFilters[newPreferenceId] = {
                        ...filter,
                        extras: JSON.stringify({originalFilterId: selectedFilterOption.value}),
                        information: JSON.stringify(filterDiff)
                    };
                    setCustomFilters(localCustomFilters);
                    
                    const localFilterThatApplyToAlias = structuredClone(filterThatApplyToAlias);
                    localFilterThatApplyToAlias.push(filter);
                    
                    setFilterThatApplyToAlias(localFilterThatApplyToAlias)
                    resolveRoleMap(localFilterThatApplyToAlias);
                    setSelectedFilterOption(filter);
                },
                (createError) => {
                    reject(createError)
                }
            );
        })
        await createFilter;
        return filterDiff || {};
    };

    const deleteCurrentFilters = (customFilter) => {
        const originalFilterId = customFilter?.extra?.originalFilterId;
        const customFilterId = customFilter?.value;
        deletePreference(customFilterId, null, () => {
            const filter = filterThatApplyToAlias.find(filter => filter.value === originalFilterId);
            setSelectedFilterOption(filter);

            const filteredFilterthatApplyToAlias = filterThatApplyToAlias.filter(filter => filter.value != customFilterId)
            const localFilterThatApplyToAlias = structuredClone(filteredFilterthatApplyToAlias);
            setFilterThatApplyToAlias(localFilterThatApplyToAlias)

            const localCustomFilters = structuredClone(customFilters);
            delete localCustomFilters[customFilterId];
            setCustomFilters(localCustomFilters);
        }, (error) => {
            console.error("ERROR", error)
        })
    }

    const onFilterChanged = (event) => {
        setHasFilterDiff(Object.keys(getFilterDiff()).length > 0);
        if (event.source != 'columnFilter' || event?.columns?.length <= 0) {
            return
        }
        const gridApi = gridRef.current.api;
        const currentModel = gridApi?.getFilterModel();
        let missingColumns = []
        for (const colName in tancFilterModel) {
            if (!currentModel.hasOwnProperty(colName)) {
                currentModel[colName] = tancFilterModel[colName]
                missingColumns.push(colName)
            }
        }
        if (missingColumns.length > 0) {
            applyFilterModel(currentModel)
        }
        const columnField = event?.columns[0]?.getColDef()?.field;
        if (tancFilterModel?.hasOwnProperty(columnField) && JSON.stringify(currentModel[columnField]) !==
            JSON.stringify(tancFilterModel[columnField])) {
            // replace the set filtertype, leave the remaining
            if (!currentModel.hasOwnProperty(columnField)) {
                // the SET filter that is default applied is removed
                currentModel[columnField] = tancFilterModel[columnField]
            } else {
                let foundSet = false
                if (currentModel[columnField]?.filterModels == null) {
                    currentModel[columnField].filterModels = []
                }
                for (const i in currentModel[columnField]?.filterModels) {
                    if (currentModel[columnField]?.filterModels[i]?.filterType == 'set') {
                        // replace this
                        foundSet = true
                        // is changed?
                        if (JSON.stringify(currentModel[columnField].filterModels[i].values || []) !== JSON.stringify(tancFilterModel[columnField].filterModels[0].values || [])) {
                            notifyFlashMessages({ 'type': 'warning', header: 'Default filter keys cannot be changed.', messages: [`Altering the filters for ${Object.keys(tancFilterModel)} is not allowed.`] })
                        }
                        currentModel[columnField].filterModels[i] = tancFilterModel[columnField].filterModels[0]
                    }
                }
                if (!foundSet) {
                    // the SET filter that is default applied is removed/changed
                    currentModel[columnField].filterModels.push(tancFilterModel[columnField].filterModels[0])
                }
            }
            applyFilterModel(currentModel)
        } else {
            updateGridInfo();
        }
    };

    const onViewportChanged = () => {
        updateGridInfo();
    };

    const updateGridInfo = () => {
        if (gridRef?.current?.api) {
            const api = gridRef.current.api;
            setGridInfo({
                rowCount: api?.getDisplayedRowCount(),
                totalRows: dsInfo?.length,
            });
        }
    };

    function resetSaveRequestModal(){
        setShowSaveModal(false)
        setSaveRequestComment(null)
    }
    function resetSyncRequestModal() {
        setSyncLoaderMessage(null)
        setShowSyncRequestCommentModal(false)
        setSyncRequestComment(null)
    }

    function resetHistoryModal() {
        setShowHistoryModal(false)
        setHistoryErrorMessage(null)
        setHistoryLoaderMessage(null)
    }

    function getHistory() {
        if (sessionDetails?.sessionId) {
            setHistoryLoaderMessage("Fetching history..")
            listTANCVersions(sessionDetails?.sessionId, function onSuccess(response) {
                const sortedSet = new Set(
                    [...response?.data?.listTANCVersions].sort((a, b) => b.lastUpdatedTimestamp - a.lastUpdatedTimestamp)
                );
                if (sortedSet) {
                    setHistoryData(Array.from(sortedSet))
                }
                setHistoryLoaderMessage(null)
            }, function onFailure(error) {
                setHistoryData([])
                setHistoryLoaderMessage(null)
                setHistoryErrorMessage(`Error fetching versions. ${error?.errors[0]?.message}`)
            })
        }
    }

    function requestSync() {
        if (syncRequestComment) {
            setSyncLoaderMessage(`Requesting data sync from ${props?.tancDetails?.upstream_type}...`)
            tancSync(sessionDetails.sessionId, "UPDATE", "ABC", syncRequestComment, function onSuccess(response) {
                resetSyncRequestModal()
            }, function onFailure(error) {
                setRequestSyncCommentErrorMessage(`Failed to sync. ${error?.errors[0]?.message}`)
            })
        } else {
            // error
            setSyncLoaderMessage(null)
            setRequestSyncCommentErrorMessage('Comments are required for requesting data sync')
        }
    }

    const onRangeSelectionChanged = useCallback((event) => {
        setAggregationValues(null)
        const gridApi = event.api;
        const cellRanges = gridRef?.current?.api?.getCellRanges();
        let count = 0
        let min = null
        let max = null
        let sum = 0

        if (cellRanges) {
            cellRanges.forEach(range => {
                range.columns.forEach(column => {
                    const colId = column?.getColId();
                    const valueGetter = column?.getColDef()?.valueGetter;

                    for (let rowIndex = range?.startRow?.rowIndex; rowIndex <= range?.endRow?.rowIndex; rowIndex++) {
                        const node = gridApi?.getDisplayedRowAtIndex(rowIndex);
                        if (!node) continue;

                        let value;
                        if (valueGetter) {
                            value = valueGetter({
                                data: node?.data,
                                node: node,
                                column: column,
                                api: gridApi
                            });
                        } else {
                            value = node?.data[colId];
                        }

                        if (!isNumber(value)) {
                            continue
                        }
                        count = count + 1
                        sum = sum + value
                        if (min == null || value < min) {
                            min = value
                        }
                        if (max == null || value > max) {
                            max = value
                        }
                    }
                });
            });
        }
        if (count > 0) {
            setAggregationValues({
                'average': formatFloatNumber(sum / count),
                'count': count,
                'sum': formatFloatNumber(sum),
                'min': formatFloatNumber(min),
                'max': formatFloatNumber(max)
            })
        }

    }, [])

    const onColumnRowGroupChanged = useCallback(() => {
        setRowGroupColumns(gridRef?.current?.api?.getRowGroupColumns())
        updateGridInfo()
    }, [])

    const lockSession = () => {
        if (sessionDetails?.sessionId) {
            createAuditLog(`TANC_SESSION#${sessionDetails.sessionId}`, `LOCK_SESSION#${Date.now()}`, "Acquiring lock for the session from Accounting central", JSON.stringify(sessionDetails), null, "TANK LOCK SESSION ON UI", userId)
            updateTANCLock(sessionDetails.sessionId, true, userId, "Editing data", function onSuccess(response) {
                setSessionDetails({ ...sessionDetails, isLocked: response?.data?.updateTANCLock?.isLocked, lockedBy: response?.data?.updateTANCLock?.lockedBy })
            }, function onFailure(response) {
                setAnnotationError("Failed to lock!")
            })
        }
    }

    const unlockSession = () => {
        if (sessionDetails?.sessionId) {
            createAuditLog(`TANC_SESSION#${sessionDetails.sessionId}`, `UNLOCK_SESSION#${Date.now()}`, "Releasing lock for the session from Accounting central", JSON.stringify(sessionDetails), null, "TANK UNLOCK SESSION ON UI", userId)
            updateTANCLock(sessionDetails.sessionId, false, null, null, function onSuccess(response) {
                setSessionDetails({ ...sessionDetails, isLocked: response?.data?.updateTANCLock?.isLocked, lockedBy: response?.data?.updateTANCLock?.lockedBy })
                setHasUnsavedFormula(false);
                setPendingFormula(null);
                setPendingFormulaRemoval(null);
                setShowColumnFormulaOverrideWarning(null);
                temporaryEditFormulaCellsRef.current.clear();
            }, function onFailure(response) {
                setAnnotationError("Failed to unlock!")
            })
        }
    }

    function getCleanedS3Key(uri) {
        if (!uri) throw new Error('S3 URL is required');
        let key=null
        let prefix=null
        if(uri.startsWith('s3://')){
            uri = uri.replace('s3://', '');
            let [bucketName, uriPrefix, ...keyParts] = uri.split('/');
            if (!bucketName) throw new Error('Invalid S3 URL: no bucket name');
            prefix = uriPrefix
            key = keyParts.join('/');
        }else{
            let [uriPrefix, ...keyParts] = uri.split('/');
            prefix = uriPrefix
            key = keyParts.join('/');
        }
        return [prefix, key]
    }

    function resubmitVersionPrompt(versionData) {
        setShowHistoryModal(null)
        if (!(undoEditCount <= 0 || rowGroupColumns?.length > 0)) {
            setResubmitVersionData(versionData)
        } else {
            resubmitVersion(versionData)
        }

    }
    function resetResubmitModal() {
        setResubmitVersionData(null)
    }

    async function resubmitVersion(versionData, resetView = false) {
        resetResubmitModal()
        cleanViewBeforeLoad(resetView)
        configureTANCS3()
        getPresignedUrlForVersionFile(sessionDetails?.sessionId, versionData.version, function onSuccess(response) {
            let presigned_url = JSON.parse(response?.data?.getPresignedUrlForVersionFile)?.url
            d3.csv(presigned_url).then((result) => {
                setResubmitTimestamp({ 'timestamp': versionData?.lastUpdatedTimestamp, 'versionData': versionData })
                setViewOnTheGrid(result)
                resetHistoryModal()
            }).catch((response) => {
                setAnnotationLoader(null)
                setAnnotationError('Loading failed')
            });
        }, function onFailure(response) {
            setAnnotationError("Failed to fetch the version file!")
        })
    }

    async function downloadVersionFile(uri, version, bucket = null) {
        if (sessionDetails?.sessionId) {
            getPresignedUrlForVersionFile(sessionDetails?.sessionId, version, function onSuccess(response) {
                let presigned_url = JSON.parse(response?.data?.getPresignedUrlForVersionFile)?.url
                window.open(presigned_url)
            }, function onFailure(response) {
                setHistoryErrorMessage("Failed to fetch the version file!")
            })
        }
    }


    async function downloadFile(uri, bucket = null) {
        
        let [prefix, key] = getCleanedS3Key(uri)
        let arr = key.split('.')
        let contentType = arr[arr.length - 1]
        let service;
        if (bucket == null || bucket?.toLowerCase()?.endsWith('tanc')) {
            configureTANCS3()
            service = VAULT_SERVICES.TANC
        } else if (bucket?.toLowerCase()?.endsWith('frisco')) {
            configureFriscoS3()
            service = VAULT_SERVICES.FRISCO
        } else if (bucket?.toLowerCase()?.endsWith('flexico')) {
            configureFlexicoS3()
            service = VAULT_SERVICES.FLEXICO
        }
        // let result = await Storage.get(key, { level: 'public', customPrefix: { public: `${prefix}/` }, expires: 60 });
        let serviceParams = {"file_path": `${prefix}/${key}`}
        // For TANC service, use tancId/sessionId. For FRISCO/FLEXICO, the TANC session
        // context only has TANC identifiers, so pass them — the path validation still
        // constrains access to the correct S3 prefix.
        if (sessionDetails?.tancId) serviceParams.service_id = `${sessionDetails.tancId}`
        if (sessionDetails?.sessionId) serviceParams.app_id = `${sessionDetails.sessionId}`
        let document = await getDocumentFromVault(contentType, service, serviceParams)                
        let fileURL = document?.fileUrl
        window.open(fileURL);
    }

    // using this variable to check user access
    function resolveRoleMap(filtersThatApply) {
        let userMapRole = {isAllowedUser: false, isAdmin: false, isEditor: false, isReviewer: false}
        for(let filter of filtersThatApply){
            userMapRole['isAllowedUser'] = true
            if (filter?.extra?.role == 'ADMIN') {
                userMapRole['isAdmin'] = true
            }
            if (filter?.extra?.role == 'EDITOR') {
                userMapRole['isEditor'] = true
            }
            if (filter?.extra?.role == 'REVIEWER') {
                userMapRole['isReviewer'] = true
            }
        }
        setTancUserRoleMap(userMapRole)
    }

    function findAndApplyFilters(ldaps, permissions, filters, customFilters) {
        let filtersThatApply = []
        let ldapDefaultFilter = null
        for (const i in permissions) {
            let permission = permissions[i]
            if (permission?.type == 'USER' && permission.alias == userId) {
                let option = {
                    'label': filters[permission.filter]?.label, 'value': permission.filter,
                    'extra': permission, tags: [permission.role]
                }
                ldapDefaultFilter = option
                setSelectedFilterOption(option)
                filtersThatApply.push(option)
            } else if (permission?.type == 'LDAP' && ldaps?.includes(permission.alias)) {
                let filterVal = {
                    'label': filters[permission.filter]?.label,
                    'value': permission.filter, 'extra': permission, tags: [permission.role, permission.alias]
                }
                filtersThatApply.push(filterVal)
                if (ldapDefaultFilter == null || filters[permission.filter]?.lastUpdatedTimestamp < ldapDefaultFilter?.lastUpdatedTimestamp) {
                    filterVal['lastUpdatedTimestamp'] = filters[permission.filter]?.lastUpdatedTimestamp || 9999999999
                    ldapDefaultFilter = filterVal
                }
            }
        }

        Object.keys(customFilters).forEach(customFilterKey => {
            const customFilter = customFilters[customFilterKey];
            const option = {
                label: customFilter.label,
                value: customFilter.preferenceId,
                extra: JSON.parse(customFilter.extras),
                tags: [PERSONAL_TAG, CUSTOM_TAG]
            }
            filtersThatApply.push(option);
        })

        if (selectedFilterOption == null && ldapDefaultFilter) {
            setSelectedFilterOption(ldapDefaultFilter)
        }

        resolveRoleMap(filtersThatApply)
        setFilterThatApplyToAlias(filtersThatApply)
    }

    function loadAllPreferences(onResult) {
        if (props?.tancDetails?.tanc_id) {
            listPreference(props.tancDetails.tanc_id, 'TANC', null, function onSuccess(response) {
                let items = response?.data?.listPreference?.items || []
                let filters = {}
                for (const i in items) {
                    if (items[i].preferenceType == 'FILTER') {
                        filters[items[i].preferenceId] = items[i]
                    }
                }
                let customFilters = {}
                for (const i in items) {
                    if (items[i].preferenceType == `CUSTOM_FILTER#${userId}`) {
                        customFilters[items[i].preferenceId] = items[i]
                    }
                }
                setFilters(filters)
                setCustomFilters(customFilters)
                for (const i in items) {
                    if (items[i].preferenceType == 'CONFIGURATION') {
                        let info = JSON.parse(items[i].information)
                        let transformedConfigurationMapper = {}
                        for (const i in info) {
                            transformedConfigurationMapper[info[i].column_name] = info[i]
                        }
                        setConfigurationMap(transformedConfigurationMapper)
                    } else if (items[i].preferenceType == 'PERMISSIONS') {
                        let information = JSON.parse(items[i].information)
                        // check if the user id belongs to one of aliases or users
                        //  fetch all ldaps for the alias and compare
                        getBrassAllLDAPS(currentStage, function onSuccess(response) {
                            let ldaps = response?.data?.getBrassAllLDAPS
                            findAndApplyFilters(ldaps, information, filters, customFilters)
                        }, function onFailure(response) {
                            findAndApplyFilters(null, information, filters, customFilters)
                        })
                    } else if (items[i].preferenceType == 'TANC-FORMULAS') {
                        try {
                            const formulaData = JSON.parse(items[i].information)
                            const formulas = formulaData?.formulas || {}
                            const columnFormulas = formulaData?.columnFormulas || {}
                            setSavedFormulas(formulas)
                            setSavedColumnFormulas(columnFormulas)
                            setFormulaPreferenceId(items[i].preferenceId)
                            // Populate the cell-level formula store
                            Object.entries(formulas).forEach(([key, formula]) => {
                                formulaStoreRef.current.set(key, formula);
                            });
                            // Store column formulas for persistence tracking
                            Object.entries(columnFormulas).forEach(([key, value]) => {
                                columnFormulaStoreRef.current.set(key, value);
                            });
                        } catch (e) {
                            setSavedFormulas({})
                            setSavedColumnFormulas({})
                        }
                    }
                }
                if (onResult) {
                    onResult(response)
                }
            }, function onFailure(response) {
            })
        }
    }

    const getDate = (value) => {
        try {
            var d = new Date(Number(value))
            return d.toLocaleString()
        } catch (e) {
            return ''
        }
    }

    const isCustomFilterSelected = () => selectedFilterOption?.tags[0] === PERSONAL_TAG;

    const formulaStoreRef = useRef(new Map());
    const columnFormulaStoreRef = useRef(new Map());
    const temporaryEditFormulaCellsRef = useRef(new Set());

    const totalRowsRef = useRef(0);

    const buildFormulaForRow = (formula, anchorRowIndex, targetRowIndex) => {
        const totalRows = totalRowsRef.current;
        const offset = targetRowIndex - anchorRowIndex;

        if (offset === 0) return formula;

        // Apply offset to each ROW reference
        let result = formula.replace(/ROW\("(\d+)"\)/g, (match, row) => {
            const newRow = parseInt(row, 10) + offset;
            return `ROW("${newRow}")`;
        });

        // Replace any REF containing an out-of-bounds ROW with 0
        result = result.replace(/REF\((?:[^()]*|\([^()]*\))*\)/g, (refMatch) => {
            let hasOutOfBounds = false;
            refMatch.replace(/ROW\("(-?\d+)"\)/g, (m, r) => {
                const rowNum = parseInt(r, 10);
                if (rowNum < 0 || rowNum >= totalRows) {
                    hasOutOfBounds = true;
                }
                return m;
            });
            return hasOutOfBounds ? '0' : refMatch;
        });

        return result;
    };

    const clearCellFormulasForColumn = (colId) => {
        formulaStoreRef.current.forEach((_, key) => {
            if (key.endsWith(`-${colId}`)) {
                formulaStoreRef.current.delete(key);
            }
        });
    };

    const restoreFormulasFromSaved = () => {
        formulaStoreRef.current.clear();
        columnFormulaStoreRef.current.clear();
        if (savedFormulas) {
            Object.entries(savedFormulas).forEach(([key, formula]) => {
                formulaStoreRef.current.set(key, formula);
            });
        }
        if (savedColumnFormulas) {
            Object.entries(savedColumnFormulas).forEach(([key, value]) => {
                columnFormulaStoreRef.current.set(key, value);
            });
        }
    };

    const resetFormulaUIState = () => {
        temporaryEditFormulaCellsRef.current.clear();
        setPendingFormula(null);
        setPendingFormulaRemoval(null);
        setShowColumnFormulaOverrideWarning(null);
    };

    const applyColumnFormulaToRefs = (colId, formula, anchorRowIndex) => {
        columnFormulaStoreRef.current.set(colId, { formula, anchorRowIndex });
        clearCellFormulasForColumn(colId);
        temporaryEditFormulaCellsRef.current.clear();
    };

    const applyFormulaToSingleCell = useCallback((rowId, colId, formula) => {
        const key = `${rowId}-${colId}`;
        if (formula === undefined) {
            formulaStoreRef.current.delete(key);
        } else {
            formulaStoreRef.current.set(key, formula);
        }
        setHasUnsavedFormula(true);
        if (gridRef?.current?.api) {
            gridRef.current.api.refreshCells({ force: true });
        }
    }, []);

    const applyFormulaToColumn = () => {
        if (!pendingFormula) return;
        if (columnFormulaStoreRef.current.has(pendingFormula.colId)) {
            const { colId, formula, anchorRowIndex } = pendingFormula;
            applyColumnFormulaToRefs(colId, formula, anchorRowIndex);
            if (gridRef?.current?.api) {
                gridRef.current.api.refreshCells({ columns: [colId], force: true });
            }
            setShowColumnFormulaOverrideWarning('column');
            return;
        }
        confirmApplyFormulaToColumn();
    };

    const confirmApplyFormulaToColumn = () => {
        if (!pendingFormula) return;
        const { colId, formula, anchorRowIndex } = pendingFormula;
        applyColumnFormulaToRefs(colId, formula, anchorRowIndex);
        setPendingFormula(null);
        setShowColumnFormulaOverrideWarning(null);
        setHasUnsavedFormula(true);
        if (gridRef?.current?.api) {
            gridRef.current.api.refreshCells({ columns: [colId], force: true });
        }
        saveFormulas();
    };

    const confirmRemoveFormula = () => {
        if (!pendingFormulaRemoval) return;
        const { colId, rowId, type } = pendingFormulaRemoval;
        if (type === 'column') {
            columnFormulaStoreRef.current.delete(colId);
            clearCellFormulasForColumn(colId);
        } else {
            formulaStoreRef.current.delete(`${rowId}-${colId}`);
        }
        temporaryEditFormulaCellsRef.current.clear();
        setPendingFormulaRemoval(null);
        setHasUnsavedFormula(true);
        if (gridRef?.current?.api) {
            gridRef.current.api.refreshCells({ columns: [colId], force: true });
        }
        saveFormulas();
    };

    const cancelFormulaRemoval = () => {
        temporaryEditFormulaCellsRef.current.clear();
        setPendingFormulaRemoval(null);
        if (gridRef?.current?.api) {
            gridRef.current.api.refreshCells({ force: true });
        }
    };

    const cancelFormulaOverride = () => {
        resetFormulaUIState();
        restoreFormulasFromSaved();
        if (gridRef?.current?.api) {
            gridRef.current.api.refreshCells({ force: true });
        }
    };

    const formulaDataSource = useMemo(() => ({
        getFormula: ({ column, rowNode }) => {
            const colId = column.getColId();
            const key = `${rowNode.id}-${colId}`;
            // Cell-level formula takes priority for immediate preview
            const cellFormula = formulaStoreRef.current.get(key);
            if (cellFormula) {
                return cellFormula;
            }
            // Skip column formula for cells where user typed a plain value (pending removal)
            if (temporaryEditFormulaCellsRef.current.has(key)) {
                return undefined;
            }
            // Fall back to column-level formula
            const colFormula = columnFormulaStoreRef.current.get(colId);
            if (colFormula) {
                const rowRef = parseInt(rowNode.id, 10);
                if (!isNaN(rowRef)) {
                    return buildFormulaForRow(colFormula.formula, colFormula.anchorRowIndex, rowRef);
                }
            }
            return undefined;
        },
        setFormula: ({ column, rowNode, formula }) => {
            const colId = column.getColId();
            if (formula === undefined) {
                // Formula is being removed
                if (columnFormulaStoreRef.current.has(colId)) {
                    temporaryEditFormulaCellsRef.current.add(`${rowNode.id}-${colId}`);
                    setPendingFormulaRemoval({ colId, rowId: rowNode.id, type: 'column' });
                } else if (formulaStoreRef.current.has(`${rowNode.id}-${colId}`)) {
                    temporaryEditFormulaCellsRef.current.add(`${rowNode.id}-${colId}`);
                    setPendingFormulaRemoval({ colId, rowId: rowNode.id, type: 'cell' });
                } else {
                    applyFormulaToSingleCell(rowNode.id, colId, undefined);
                }
            } else {
                applyFormulaToSingleCell(rowNode.id, colId, formula);
                if (column.getColDef().allowFormula) {
                    setPendingFormula({
                        colId: colId,
                        formula: formula,
                        anchorRowIndex: parseInt(rowNode.id, 10),
                        rowId: rowNode.id
                    });
                }
            }
        },
    }), []);

    const saveSingleCellFormula = () => {
        // Check if the pending formula's column has a column formula
        if (pendingFormula && columnFormulaStoreRef.current.has(pendingFormula.colId)) {
            setShowColumnFormulaOverrideWarning('single');
            return;
        }
        setPendingFormula(null);
        setHasUnsavedFormula(true);
        saveFormulas();
    };

    const confirmSaveSingleCellFormula = () => {
        if (pendingFormula) {
            const { colId, formula, rowId } = pendingFormula;
            columnFormulaStoreRef.current.delete(colId);
            clearCellFormulasForColumn(colId);
            temporaryEditFormulaCellsRef.current.clear();
            formulaStoreRef.current.set(`${rowId}-${colId}`, formula);
        }
        setShowColumnFormulaOverrideWarning(null);
        setPendingFormula(null);
        setHasUnsavedFormula(true);
        if (gridRef?.current?.api) {
            gridRef.current.api.refreshCells({ force: true });
        }
        saveFormulas();
    };

    const saveFormulas = () => {
        if (!props?.tancDetails?.tanc_id) return;
        const isAdminRole = selectedFilterOption?.extra?.role == 'ADMIN';
        if (!isAdminRole) return;

        const formulas = {};
        formulaStoreRef.current.forEach((formula, key) => {
            formulas[key] = formula;
        });

        const columnFormulas = {};
        columnFormulaStoreRef.current.forEach((value, key) => {
            columnFormulas[key] = value;
        });

        const formulaData = { formulas, columnFormulas, lastUpdatedBy: userId, lastUpdatedAt: Date.now() };

        const getFormulaExpression = (val) => typeof val === 'object' && val !== null ? (val.formula || JSON.stringify(val)) : val;

        const buildFormulaAuditComment = () => {
            const prevFormulas = { ...(savedFormulas || {}), ...(savedColumnFormulas || {}) };
            const currFormulas = { ...formulas, ...columnFormulas };
            const added = Object.keys(currFormulas).filter(k => !prevFormulas[k]);
            const removed = Object.keys(prevFormulas).filter(k => !currFormulas[k]);
            const parts = [`TANC ${props.tancDetails.tanc_id}, session ${sessionDetails?.sessionId}.`];
            if (added.length) parts.push(`Formula(s) added: ${added.map(k => getFormulaExpression(currFormulas[k])).join(', ')}.`);
            if (removed.length) parts.push(`Formula(s) removed: ${removed.map(k => getFormulaExpression(prevFormulas[k])).join(', ')}.`);
            if (!added.length && !removed.length) parts.push(`Formula(s) updated: ${Object.values(currFormulas).map(v => getFormulaExpression(v)).join(', ')}.`);
            return JSON.stringify(parts.join(' ')).slice(1, -1);
        };

        if (formulaPreferenceId) {
            updatePreferenceWithExtras(
                formulaPreferenceId,
                'Session Formulas',
                userId,
                formulaData,
                { sessionId: sessionDetails?.sessionId, version: (Object.keys(savedFormulas || {}).length > 0 ? 2 : 1) },
                function onSuccess() {
                    createAuditLog(`FRISCO#${props.tancDetails.association_id}`, `${Date.now()}`, buildFormulaAuditComment(), JSON.stringify({ formulas: savedFormulas, columnFormulas: savedColumnFormulas }), JSON.stringify(formulaData), "SAVE_FORMULAS", userId);
                    setSavedFormulas(formulas);
                    setSavedColumnFormulas(columnFormulas);
                    setAnnotationSaveSuccessMessage("Formula saved successfully");
                    setTimeout(() => setAnnotationSaveSuccessMessage(null), 3000);
                },
                function onFailure(error) {
                    console.error('Failed to save formulas:', error);
                    setAnnotationError("Failed to save formula");
                }
            );
        } else {
            const newId = uuidv4();
            createPreferenceWithExtras(
                newId,
                'TANC-FORMULAS',
                'Session Formulas',
                props.tancDetails.tanc_id,
                'TANC',
                userId,
                formulaData,
                { sessionId: sessionDetails?.sessionId, version: 1 },
                null,
                function onSuccess() {
                    createAuditLog(`FRISCO#${props.tancDetails.association_id}`, `${Date.now()}`, buildFormulaAuditComment(), JSON.stringify({}), JSON.stringify(formulaData), "SAVE_FORMULAS", userId);
                    setFormulaPreferenceId(newId);
                    setSavedFormulas(formulas);
                    setSavedColumnFormulas(columnFormulas);
                    setAnnotationSaveSuccessMessage("Formula saved successfully");
                    setTimeout(() => setAnnotationSaveSuccessMessage(null), 3000);
                },
                function onFailure(error) {
                    console.error('Failed to create formula preference:', error);
                    setAnnotationError("Failed to save formula");
                }
            );
        }
    };

    return (
        <SpaceBetween direction="vertical" size="m">
            {
                flashMessages && <Flashbar items={flashMessages} />
            }
            {
                resubmitTimestamp && <Grid
                    gridDefinition={[{ colspan: 10 }, { colspan: 2 }]}
                >
                    <Alert type="warning">
                        This data was previously loaded on {getDate(resubmitTimestamp?.['timestamp'])}
                    </Alert>
                    {
                        props?.showSubmit && sessionDetails?.status != 'INACTIVE'  && <Button variant='primary' onClick={(() => submitAnnotated())} disabled={sessionDetails?.isLocked}>Submit</Button>
                    }
                    {
                        props?.showSave && sessionDetails?.status != 'INACTIVE'  && <Button variant='primary' onClick={(() => setShowSaveModal(true))} disabled={sessionDetails?.isLocked && sessionDetails?.lockedBy != userId}>Save</Button>
                    }
                    
                </Grid>
            }
            <SpaceBetween direction="vertical">
                <Grid
                    gridDefinition={[
                        { colspan: { default: 3, xxs: 3 } },
                        { colspan: { default: 9, xxs: 9 } }
                    ]}
                >
                    <Box padding="m">
                        <SpaceBetween direction="horizontal" size="xs">
                            {annotationLoader ? <Box> <Spinner></Spinner>{annotationLoader}</Box> : <></>}
                            {annotationError ? <Box> <span className="error_message">{annotationError}</span> </Box> : <></>}
                            {
                                (selectedFilterOption?.extra?.role == 'ADMIN' && (!(undoEditCount <= 0 || rowGroupColumns?.length > 0) || hasUnsavedFormula)) ? <Box><StatusIndicator type="warning">Attention: You have unsaved work</StatusIndicator></Box> : ''
                            }
                            {
                                pendingFormula && !showColumnFormulaOverrideWarning && sessionDetails?.isLocked && sessionDetails?.lockedBy == userId && selectedFilterOption?.extra?.role == 'ADMIN' ? <Box><SpaceBetween direction="vertical" size="s">{columnFormulaStoreRef.current.has(pendingFormula.colId) && <StatusIndicator type="warning">Saving the current formula change will remove the existing formula applied to this column/cell.</StatusIndicator>}<StatusIndicator type="info">A formula has been submitted. Would you like to save it?</StatusIndicator><SpaceBetween direction="horizontal" size="xs"><Button variant="primary" onClick={() => saveSingleCellFormula()}>Save formula for cell</Button><Button variant="primary" onClick={() => applyFormulaToColumn()}>Save formula for column</Button></SpaceBetween></SpaceBetween></Box> : ''
                            }
                            {
                                pendingFormulaRemoval && sessionDetails?.isLocked && sessionDetails?.lockedBy == userId && selectedFilterOption?.extra?.role == 'ADMIN' ? <Box><SpaceBetween direction="horizontal" size="xs"><StatusIndicator type="warning">{pendingFormulaRemoval.type === 'column' ? `The existing column formula for all rows in column: "${pendingFormulaRemoval.colId}" will be removed.` : `The existing formula for this cell will be removed.`}</StatusIndicator><Button variant="primary" onClick={() => confirmRemoveFormula()}>Confirm removal</Button><Button variant="link" onClick={() => cancelFormulaRemoval()}>Cancel</Button></SpaceBetween></Box> : ''
                            }
                            {
                                showColumnFormulaOverrideWarning ? <Box><SpaceBetween direction="horizontal" size="xs"><StatusIndicator type="warning">The previous formula for this column will be removed.</StatusIndicator><Button variant="normal" onClick={() => showColumnFormulaOverrideWarning === 'single' ? confirmSaveSingleCellFormula() : confirmApplyFormulaToColumn()}>Confirm formula update</Button><Button variant="link" onClick={() => cancelFormulaOverride()}>Cancel</Button></SpaceBetween></Box> : ''
                            }
                            {
                                annotationSaveSuccessMessage ? <StatusIndicator type="success">{annotationSaveSuccessMessage}</StatusIndicator> : ''
                            }
                        </SpaceBetween>
                    </Box>
                    <Box float="right" padding="m">
                        <SpaceBetween direction="horizontal" size="xl">
                            {
                                viewers && Object.keys(viewers).length > 0 ?
                                    <Box>
                                        <Popover
                                            header="Viewing the session"
                                            content={<>
                                                {
                                                    Object.keys(viewers).map((key) => {
                                                        return <Box><SpaceBetween direction="horizontal" size="s">
                                                            <img
                                                                alt=""
                                                                className="rounded-circle"
                                                                src={
                                                                    "https://badgephotos.corp.amazon.com/?uid=" +
                                                                    key
                                                                }
                                                                width={10}
                                                                height={10}
                                                            />
                                                            <Box textAlign="center">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    href={"https://phonetool.amazon.com/users/" + key}
                                                                >
                                                                    {key}
                                                                </a>
                                                            </Box>
                                                        </SpaceBetween></Box>
                                                    })
                                                }
                                            </>}
                                        >
                                            {Object.keys(viewers).length} viewing
                                        </Popover>
                                    </Box> : <></>
                            }
                            <Button variant="icon" iconName="refresh" onClick={(() => {
                                setResubmitTimestamp(null);
                                formulaStoreRef.current.clear();
                                columnFormulaStoreRef.current.clear();
                                setHasUnsavedFormula(false);
                                setPendingFormula(null);
                                setPendingFormulaRemoval(null);
                                setShowColumnFormulaOverrideWarning(null);
                                getAnnotationInput()
                                loadAllPreferences()
                            })}></Button>
                            <Select
                                selectedOption={selectedFilterOption}
                                onChange={({ detail }) => 
                                    setSelectedFilterOption(detail.selectedOption)
                                }
                                options={filterThatApplyToAlias}
                                triggerVariant="option"
                            />

                            {
                                props?.showSave && sessionDetails?.status != 'INACTIVE' ?
                                    <Button onClick={(() => setShowSaveModal(true))} disabled={(undoEditCount <= 0 && !hasUnsavedFormula) || rowGroupColumns?.length > 0}>Save</Button>
                                    :
                                    <></>
                            }
                            {
                                props?.showSubmit && sessionDetails?.status != 'INACTIVE'?
                                    <Button variant='primary' onClick={(() => submitAnnotated())} disabled={((undoEditCount <= 0 && !hasUnsavedFormula) || rowGroupColumns?.length > 0) || (!sessionDetails?.isLocked)}>Submit</Button>
                                    :
                                    <></>
                            }


                            <ButtonDropdown
                                items={[
                                    {
                                        text: "Export to excel",
                                        items: [
                                            { text: "Current view", id: "current_view", disabled: false },
                                            { text: "Selected rows", id: "selected_rows", disabled: false },
                                            { text: "Original", id: "original", disabled: selectedFilterOption?.value != 'All' }
                                        ]
                                    },
                                    {
                                        text: "Import",
                                        items: [
                                            // { text: "Upload from excel", id: "import_csv", disabled: false },
                                            { text: "Add additional data from excel", id: "import_csv_append", disabled: !props.canEdit }
                                        ]
                                    },
                                    {
                                        text: "Manage Custom filters",
                                        items: [
                                            { text: "Save current custom filters", id: "save_filters", disabled: !hasFilterDiff || isCustomFilterSelected() },
                                            { text: "Delete current custom filters", id: "delete_filters", disabled: !isCustomFilterSelected() },
                                        ]
                                    },
                                    { text: "Request sync", id: "request_sync", disabled: !(isPortalAdmin || isSupportAdmin || tancUserRoleMap?.isAdmin) || (props.tancDetails?.association_id_type=='FLEXICO' || sessionDetails?.status == 'INACTIVE') },
                                    { text: "History", id: "history", disabled: !(isPortalAdmin || isSupportAdmin || tancUserRoleMap?.isAllowedUser) }
                                ]}
                                onItemClick={(event) => {
                                    if (event.detail.id == 'current_view') {
                                        exportAnnotated({ 'filtered': true })
                                    } else if (event.detail.id == 'selected_rows') {
                                        exportAnnotated({ 'selectedOnly': true })
                                    }
                                    else if (event.detail.id == 'original') {
                                        exportAnnotated()
                                    } else if (event.detail.id == 'import_csv') {
                                        setShowAnnotationImportModal(true)
                                    } else if (event.detail.id == 'import_csv_append') {
                                        setShowAnnotationImportAppendModal(true)
                                    } else if (event.detail.id == 'request_sync') {
                                        setShowSyncRequestCommentModal(true)
                                    } else if (event.detail.id == 'history') {
                                        getHistory()
                                        setShowHistoryModal(true)
                                    } else if (event.detail.id == 'save_filters') {
                                        setShowSaveCurrentFiltersModal(true);
                                        setCurrentFilterName(`${selectedFilterOption.label ? selectedFilterOption.label : "All"} - `)
                                    } else if (event.detail.id == 'delete_filters') {
                                        deleteCurrentFilters(selectedFilterOption)
                                    }
                                }}
                            >
                                Actions
                            </ButtonDropdown>
                            {/* <Button variant="icon" iconName="unlocked" onClick={(()=>handleViewChanges())}></Button> */}
                            <SpaceBetween direction='vertical' size='m'>
                                {
                                    !sessionDetails?.isLocked && selectedFilterOption && isEditorRole() && userId ? <Button disabled={sessionDetails?.isLocked == true || sessionDetails?.status == 'INACTIVE'} onClick={lockSession} variant='primary'>Edit</Button> : <></>
                                }
                                <SpaceBetween direction='horizontal' size='m'>
                                {
                                    sessionDetails?.isLocked && sessionDetails?.lockedBy == userId && <>
                                            <Button onClick={(() => addRowToAnnotation())} iconName="insert-row">Add</Button>
                                            <Button onClick={(() => delRowToAnnotation())} disabled={multiSelectedRow?.length <= 0} iconName="delete-marker">Delete</Button>
                                        </>
                                }
                                {
                                    (sessionDetails?.isLocked && (sessionDetails?.lockedBy == userId || tancUserRoleMap?.isAdmin || tancUserRoleMap?.isReviewer || isPortalAdmin || isSupportAdmin)) && <>
                                    <Button onClick={() => {
                                                restoreFormulasFromSaved();
                                                unlockSession()
                                                getAnnotationInput()
                                                loadAllPreferences()
                                            }}>Cancel edit</Button></>
                                }
                                 </SpaceBetween>

                                <SpaceBetween direction='vertical' size='xxxs'>
                                    {
                                        sessionDetails?.isLocked && sessionDetails?.lockedBy && sessionDetails?.lockedBy != 'null' ? <Box> <span className='grey_text'>Locked by {sessionDetails?.lockedBy} {sessionDetails.lockLastUpdatedTimestamp ? `at ${new Date(parseInt(sessionDetails.lockLastUpdatedTimestamp)).toLocaleString()}` : ''}</span></Box> : <></>
                                    }
                                    {
                                        sessionDetails?.isLocked && sessionDetails?.lockMessage && sessionDetails?.lockedBy != userId ?
                                            <Box><span className='grey_text'>{sessionDetails?.lockMessage}</span></Box> : <></>
                                    }
                                </SpaceBetween>

                            </SpaceBetween>
                        </SpaceBetween>
                    </Box>
                </Grid>
                {
                    selectedFilterOption ?
                        <div style={{
                            width: '100%',
                            height: 'calc(100vh - 200px)',
                        }}>
                            <div
                                className="ag-theme-alpine"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    minHeight: '500px'
                                }}
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    theme="legacy"
                                    rowData={dsInfo}
                                    defaultColDef={defaultProjectColDef}
                                    columnDefs={columnsList}
                                    getRowId={(params) => params.data._tancRowId}
                                    formulaDataSource={formulaDataSource}
                                    rowSelection='multiple'
                                    onSelectionChanged={onSelectionChanged}
                                    suppressRowClickSelection={true}
                                    rowMultiSelectWithClick={true}
                                    rowNumbers={true}
                                    // editType={"fullRow"}
                                    animateRows={true}
                                    rowHeight={30}
                                    enableCellTextSelection={false}
                                    undoRedoCellEditing={true}
                                    undoRedoCellEditingLimit={10}
                                    onCellValueChanged={onCellValueChanged}
                                    onCellFocused={onCellFocused}
                                    onGridReady={onGridReady}
                                    onRowDataUpdated={onRowDataUpdated}
                                    onColumnRowGroupChanged={onColumnRowGroupChanged}
                                    rowGroupPanelShow={(sessionDetails?.isLocked && sessionDetails?.lockedBy == userId) || (formulaStoreRef.current.size > 0) || (columnFormulaStoreRef.current.size > 0) ? "never" : "always"}
                                    sideBar={sideBar}
                                    // groupTotalRow="bottom"
                                    groupAggFiltering={false}
                                    suppressAggFuncInHeader={false}
                                    cellSelection={true}
                                    onRangeSelectionChanged={onRangeSelectionChanged}
                                    getContextMenuItems={getContextMenuItems}
                                    enableContextMenu={true}
                                    // onModelUpdated={onModelUpdated}
                                    onFilterChanged={onFilterChanged}
                                    onViewportChanged={onViewportChanged}
                                    suppressMenuHide={true}
                                    suppressScrollOnNewData={true}
                                    ensureDomOrder={true}
                                // enableAdvancedFilter={true}
                                />
                                {
                                    aggregationValues && aggregationValues?.count > 1 ?
                                        <Box float="right">
                                            <SpaceBetween direction="horizontal" size="s">
                                                <Box><span className="agg-text bold-text">Average:</span> <span className="agg-text">{aggregationValues.average}</span></Box>
                                                <Box><span className="agg-text bold-text">Count:</span> <span className="agg-text">{aggregationValues.count}</span></Box>
                                                <Box><span className="agg-text bold-text">Min:</span> <span className="agg-text">{aggregationValues.min}</span></Box>
                                                <Box><span className="agg-text bold-text">Max:</span> <span className="agg-text">{aggregationValues.max}</span></Box>
                                                <Box><span className="agg-text bold-text">Sum:</span> <span className="agg-text">{aggregationValues.sum}</span></Box>
                                            </SpaceBetween>
                                        </Box>
                                        : ''
                                }
                                {
                                    gridInfo ? <Box float="left">
                                        <SpaceBetween direction="horizontal" size="s">
                                            <Box><span className="agg-text bold-text">Filtered rows:</span> <span className="agg-text">{gridInfo.rowCount}</span></Box>
                                            <Box><span className="agg-text bold-text">Total rows:</span> <span className="agg-text">{gridInfo.totalRows}</span></Box>
                                        </SpaceBetween>
                                    </Box> : ''
                                }
                            </div>
                        </div> : <></>
                }
            </SpaceBetween>
            <Modal
                onDismiss={() => resetSyncRequestModal()}
                visible={showSyncRequestCommentModal}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" onClick={() => resetSyncRequestModal()}> Cancel</Button>
                            <Button variant="primary" onClick={() => requestSync()}>Ok</Button>
                        </SpaceBetween>
                    </Box>
                }
                header={<SpaceBetween direction='horizontal' size='s'>
                    <Box variant='h3'>Comments</Box>
                    {
                        syncLoaderMessage ? <SpaceBetween direction='horizontal' size='s'>
                            <Box color="text-status-inactive"> <Spinner></Spinner> {syncLoaderMessage}</Box>
                        </SpaceBetween> : <></>
                    }

                </SpaceBetween>}
            >
                <Textarea
                    onChange={({ detail }) => setSyncRequestComment(detail.value)}
                    value={syncRequestComment}
                    placeholder={`Please provide a reason to sync from ${props?.tancDetails?.upstream_type}`}
                />

                {requestSyncCommentErrorMessage && (
                    <Box variant="p" color="text-status-error">
                        {requestSyncCommentErrorMessage}
                    </Box>
                )}

            </Modal>
            <Modal
                onDismiss={() => resetSaveRequestModal()}
                visible={showSaveModal}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" onClick={() => resetSaveRequestModal()}> Cancel</Button>
                            <Button variant="primary" onClick={() => saveAnnotated()}>Ok</Button>
                        </SpaceBetween>
                    </Box>
                }
                header={<SpaceBetween direction='horizontal' size='s'>
                    <Box variant='h3'>Comments</Box>
                </SpaceBetween>}
            >
                <Textarea
                    onChange={({ detail }) => setSaveRequestComment(detail.value)}
                    value={saveRequestComment}
                    placeholder={`Please provide a reason to sync from ${props?.tancDetails?.upstream_type}`}
                />

                {requestSaveCommentErrorMessage && (
                    <Box variant="p" color="text-status-error">
                        {requestSaveCommentErrorMessage}
                    </Box>
                )}

            </Modal>

            <Modal
                size="max"
                onDismiss={() => resetHistoryModal()}
                visible={showHistoryModal}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            {
                                historyErrorMessage ? <Box variant="p" color="text-status-error">{historyErrorMessage}</Box> : <></>
                            }
                            <Button variant="link" onClick={() => resetHistoryModal()}> Cancel</Button>
                        </SpaceBetween>
                    </Box>
                }
                header={
                    <Box variant='h3'>History</Box>}>
                {
                    historyLoaderMessage ? <SpaceBetween direction='horizontal' size='s'>
                        <Box color="text-status-inactive"> <Spinner></Spinner> {historyLoaderMessage}</Box>
                    </SpaceBetween> : <Table
                        columnDefinitions={[
                            {
                                id: "triggerType",
                                header: "Type",
                                cell: item => item.triggerType,
                                sortingField: "name",
                                isRowHeader: true
                            },
                            {
                                id: "triggerComments",
                                header: "Comment",
                                cell: item => item.triggerComments
                            },
                            {
                                id: "triggeredBy",
                                header: "Triggered by",
                                cell: item => item.triggeredBy,
                                sortingField: "alt"
                            },
                            {
                                id: "lastUpdatedTimestamp",
                                header: "Last updated",
                                cell: item => <SpaceBetween direction='horizontal' size='m'>
                                    <span className="bold">{getDate(item?.lastUpdatedTimestamp)}</span>
                                    {
                                        item?.delta?.fileUris?.find(uri => uri?.includes('resubmitted_')) ?

                                            <Popover
                                                dismissButton={false}
                                                position="top"
                                                size="small"
                                                triggerType="custom"
                                                content={
                                                    <Box>
                                                        {getDate(historyData?.find(versionItem => item?.delta?.fileUris?.find(uri => uri?.includes('resubmitted_'))?.includes(`_${versionItem?.['version']}.csv`))?.lastUpdatedTimestamp) || ''}
                                                    </Box>
                                                }
                                            >
                                                <span className="blue_badge">Resubmitted</span>
                                            </Popover>

                                            : <></>
                                    }
                                </SpaceBetween>,
                                minWidth: 170
                            },
                            {
                                id: "files",
                                header: "",
                                cell: item => <SpaceBetween direction='horizontal' size='m'>
                                    <Button onClick={() => { downloadVersionFile(item?.s3Path, item.version) }} disabled={!(isPortalAdmin || isSupportAdmin || tancUserRoleMap?.isAllowedUser)}>
                                        File
                                    </Button>
                                    <Button onClick={() => { resubmitVersionPrompt(item) }} variant="primary" disabled={!(isPortalAdmin || isSupportAdmin || tancUserRoleMap?.isAdmin || tancUserRoleMap?.isReviewer || tancUserRoleMap?.isEditor)}>
                                        Load 
                                    </Button>
                                    {
                                        item?.delta?.bucket && item?.delta?.fileUris ? <Button onClick={() => { downloadFile(item?.delta?.fileUris?.[0], item?.delta.bucket) }} variant="inline-link" disabled={!(isPortalAdmin || isSupportAdmin || tancUserRoleMap?.isAllowedUser)}>
                                            Change file
                                        </Button> : <></>
                                    }

                                </SpaceBetween>,
                                minWidth: 170
                            }
                        ]}
                        columnDisplay={[
                            // { id: "triggerType", visible: true },
                            { id: "triggeredBy", visible: true },
                            { id: "triggerComments", visible: true },
                            { id: "lastUpdatedTimestamp", visible: true },
                            { id: "files", visible: true },
                            { id: "transactionDetails", visible: true }
                        ]}
                        enableKeyboardNavigation
                        items={historyData}
                    />
                }
            </Modal>

            <Modal
                onDismiss={() => resetResubmitModal()}
                visible={resubmitVersionData}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" onClick={() => resetResubmitModal()}> Cancel</Button>
                            <Button variant="primary" onClick={() => resubmitVersion(resubmitVersionData)}>Proceed</Button>
                        </SpaceBetween>
                    </Box>
                }
                header={<SpaceBetween direction='horizontal' size='s'>
                    <Box variant='h3'>Important: Permanent Change Warning</Box>
                </SpaceBetween>}
            >
                <SpaceBetween size='m'>
                    {
                        (!(undoEditCount <= 0 || rowGroupColumns?.length > 0)) ? <Alert type="warning">
                            You have some unsaved work!
                        </Alert> : <></>
                    }
                    <Alert type="info">
                        This will overwrite your current unsaved work with data from <span className='boldText'>{getDate(resubmitVersionData?.lastUpdatedTimestamp)}</span>.
                    </Alert>
                </SpaceBetween>

            </Modal>

            <Modal
                onDismiss={() => setShowSaveCurrentFiltersModal(false)}
                visible={showSaveCurrentFiltersModal}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" onClick={() => setShowSaveCurrentFiltersModal(false)}>Cancel</Button>
                            <Button variant="primary" onClick={() => {
                                saveCurrentFilters(currentFilterName)
                            }}>Save</Button>
                        </SpaceBetween>
                    </Box>
                }
                header="Save Current Filters"
            >
                <FormField label="Filter Name">
                    <Input                 
                        value={currentFilterName}
                        onChange={({ detail }) => {
                            setCurrentFilterName(detail.value);
                        }}
                    ></Input>
                </FormField>
            </Modal>
        </SpaceBetween>

    )
}

export default TANCSession;